import { ScheduleLifecycleChange } from "@common/schemas/domains/accounting/scheduleLifecycle.schema";
import { ScheduleRecognitionOverrides } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";

/**
 * The edit as a Change request. A source-backed amount follows its source,
 * and Change never moves the deferred account: re-posting does not re-code
 * the source, so a new holding account would split its balance.
 */
export function buildScheduleEditChange(options: {
    current: {
        sourceType: ScheduleSourceType;
        amount: number;
        termStart: string;
    };
    resolved: { amount: number; termStart: string | null };
    overrides: ScheduleRecognitionOverrides;
}): ScheduleLifecycleChange {
    const { current, resolved, overrides } = options;
    const isAmountEditable = current.sourceType === ScheduleSourceType.manual;
    return {
        ...(isAmountEditable && resolved.amount !== current.amount
            ? { amount: resolved.amount }
            : {}),
        ...(resolved.termStart && resolved.termStart !== current.termStart
            ? { termStart: resolved.termStart }
            : {}),
        ...(overrides.termLength !== undefined &&
        overrides.termUnit !== undefined
            ? { termLength: overrides.termLength, termUnit: overrides.termUnit }
            : {}),
        ...(overrides.components ? { components: overrides.components } : {}),
        ...(overrides.recognitionAccountId
            ? { recognitionAccountId: overrides.recognitionAccountId }
            : {}),
    };
}
